import { Component, OnInit } from '@angular/core';
import { ManuscriptsService } from '../../../services/manuscripts.service';
import { MssListFilters } from '../../../models/mss-list-filters';

@Component({
  selector: 'app-mss-filters-tags',
  templateUrl: './mss-filters-tags.component.html',
  styleUrls: ['./mss-filters-tags.component.css']
})
export class MssFiltersTagsComponent implements OnInit {
    mssListFilters: MssListFilters;

    constructor(
        private manuscriptsService: ManuscriptsService) {
    }

    ngOnInit(): void {
        this.manuscriptsService.getMssListFilters()
            .subscribe(response => this.mssListFilters = response,
                err => console.error(err));
    }

    removeMsType() {
        this.mssListFilters.msType = null;
        this.manuscriptsService.updateFilters(this.mssListFilters);
    }

    removeCountry() {
        this.mssListFilters.country = null;
        this.manuscriptsService.updateFilters(this.mssListFilters);
    }

    removeCity() {
        this.mssListFilters.city = null;
        this.manuscriptsService.updateFilters(this.mssListFilters);
    }

    removeLibrary() {
        this.mssListFilters.library = null;
        this.manuscriptsService.updateFilters(this.mssListFilters);
    }

    removeCopyDate() {
        this.mssListFilters.copyDate = null;
        this.manuscriptsService.updateFilters(this.mssListFilters);
    }

    removeCopyist() {
        this.mssListFilters.copyist = null;
        this.manuscriptsService.updateFilters(this.mssListFilters);
    }

    removeCopyPlace() {
        this.mssListFilters.copyPlace = null;
        this.manuscriptsService.updateFilters(this.mssListFilters);
    }

    removePatron() {
        this.mssListFilters.patron = null;
        this.manuscriptsService.updateFilters(this.mssListFilters);
    }

    removeOwner() {
        this.mssListFilters.owner = null;
        this.manuscriptsService.updateFilters(this.mssListFilters);
    }

    removeSifaSelection() {
        this.mssListFilters.sifaSelection = null;
        this.manuscriptsService.updateFilters(this.mssListFilters);
    }

    removeTimePeriod() {
        this.mssListFilters.timePeriod = null;
        this.manuscriptsService.updateFilters(this.mssListFilters);
    }
}



// WEBPACK FOOTER //
// ./src/app/components/ui/mss-filters-tags/mss-filters-tags.component.ts